import { render, staticRenderFns } from "./SequenceSuggestionItem.vue?vue&type=template&id=3d02e023&"
import script from "./SequenceSuggestionItem.vue?vue&type=script&lang=js&"
export * from "./SequenceSuggestionItem.vue?vue&type=script&lang=js&"
import style0 from "./SequenceSuggestionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports